import { Component } from "react";
import shared from "../../../shared";
import IterationVol from "./iterationVol";
import iterationVol from "./iterationVol";
var moment = require("moment-timezone");

class CollabseDetail extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const itenAller = this.props.aller;
    const itenRetour = this.props.retour;

    return (
      <div style={{ backgroundColor: "#f7f7f7" }}>
        <div>
          <h4 className="d-flex plan__header__txt ml-2 mt-2">
            {" "}
            <span className="mt-3">Aller</span>
            <div className="plan__volIcon__cont mb-3 ml-2">
              <img
                className="plan__volIcon tp-plane"
                src="/imgs/vols/planeIcon.svg"
                alt=""
              />
            </div>
          </h4>

          <div class="card-body">
            <IterationVol iten={itenAller} />
          </div>
        </div>

        <div>
          {itenRetour.length != 0 && (
            <>
              <h4 className="d-flex plan__header__txt ml-2 mt-2">
                {" "}
                <span className="mt-3">Retour</span>
                <div className="plan__volIcon__cont mb-3 ml-2">
                  <img
                    className="plan__volIcon tp-plane"
                    src="/imgs/vols/plane_rev.svg"
                    alt=""
                  />
                </div>
              </h4>

              <div class="card-body">
                <IterationVol iten={itenRetour} />
              </div>
            </>
          )}
        </div>
      </div>
    );
  }
}

export default CollabseDetail;
